export default (groups = [], action) => {
    switch (action.type){
        case 'ALL_GROUPS':
            return action.payload; 
        case 'SEARCH_GROUPS':
            return action.payload;            
        default:
            return groups;
    }
}